import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import gtmDataLayer from './plugins/gtmDatalayer'

const app = createApp(App);

app.use(gtmDataLayer);
app.use(router);
app.use(vuetify);

app.mount('#app');

// createApp(App).use(router).use(vuetify).use(gtmDataLayer).mount("#app");
